var pad = require('./pad');

module.exports = function lrpad(str, length, padStr) {
  return pad(str, length, padStr, 'both');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/lrpad.js
// module id = 824
// module chunks = 0